export default "/kiban/_next/static/images/43_12L_2-8-2-7565d7560f8d9e4e6d41699a6f96fa8a.png";